import React, { useState } from "react";
import StopifyWidget from "../StopifyWidget";
import { FaBars, FaReact } from "react-icons/fa";
import { HiX } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import "./styles.scss";

const links = [
  { label: "HOME", to: "/" },
  { label: "ABOUT ME", to: "/about" },
  { label: "SKILLS", to: "/skills" },
  { label: "RESUME", to: "/resume" },
  { label: "PORTFOLIO", to: "/portfolio" },
  { label: "CONTACT", to: "/contact" },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuId = "primary-navigation";

  const toggleMenu = () => setMenuOpen((v) => !v);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header">
      <nav className="navbar" aria-label="Primary navigation">
        <div className="navbar__inner">
          <NavLink to="/" className="navbar__logo" onClick={closeMenu} aria-label="Homepage">
            <FaReact size={28} />
          </NavLink>

          <button
            className="navbar__toggle"
            onClick={toggleMenu}
            aria-controls={menuId}
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            type="button"
          >
            {menuOpen ? <HiX size={24} /> : <FaBars size={24} />}
          </button>

          <ul
            id={menuId}
            className={`navbar__menu ${menuOpen ? "is-open" : ""}`}
            role="menubar"
          >
            {links.map((ln, idx) => (
              <li key={idx} className="navbar__item" role="none">
                <NavLink
                  to={ln.to}
                  className={({ isActive }) =>
                    `navbar__link ${isActive ? "is-active" : ""}`
                  }
                  onClick={closeMenu}
                  role="menuitem"
                >
                  {ln.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </nav>\n      <StopifyWidget />
    </header>
  );
};

export default Navbar;
